import { useMutation, useQuery } from "@apollo/client";
import { STORE_ITEM_TYPE } from "enefel/store";
import { memo, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { setPageTitle } from "../../helpers/browser";
import { BUY_ITEM, GET_USER_PURCHASES } from "../../query/StoreQueries";
import QueryError from "../Error/QueryError";
import Loading from "../Loading";
import { RootContext } from "../RootContext";
import { track } from "../../analytics";
import StoreAvatars from "./StoreAvatar";
import StoreBadges from "./StoreBadges";
import StoreDice from "./StoreDice";

const Wrapper = styled.div``;

const StoreShowWithUser = memo(({ user }) => {
  const { t } = useTranslation();

  const { setUser } = useContext(RootContext);

  useEffect(() => {
    track("store_viewed");
  }, []);
  const { loading, error, data } = useQuery(GET_USER_PURCHASES);
  const [buyItemStore, { loading: loadingBuy, error: errorBuy }] =
    useMutation(BUY_ITEM, {
      refetchQueries: [{ query: GET_USER_PURCHASES }],
    });

  const handleBuyAvatar = (itemKey) => {
    if (loading) {
      return;
    }
    buyItemStore({
      variables: {
        itemKey,
        type: STORE_ITEM_TYPE.AVATAR,
      },
    }).then(({ data }) => {
      track("item_purchased", { item_key: itemKey, item_type: STORE_ITEM_TYPE.AVATAR });
      setUser({ ...user, ...data.buyItemStore });
    });
  };
  const handleBuySeasonAvatar = (itemKey) => {
    if (loading) {
      return;
    }
    buyItemStore({
      variables: {
        itemKey,
        type: STORE_ITEM_TYPE.SEASON_AVATAR,
      },
    }).then(({ data }) => {
      track("item_purchased", { item_key: itemKey, item_type: STORE_ITEM_TYPE.SEASON_AVATAR });
      setUser({ ...user, ...data.buyItemStore });
    });
  };
  const handleBuy = (itemKey) => {
    if (loading) {
      return;
    }
    buyItemStore({
      variables: {
        itemKey,
        type: STORE_ITEM_TYPE.BADGE,
      },
    }).then(({ data }) => {
      track("item_purchased", { item_key: itemKey, item_type: STORE_ITEM_TYPE.BADGE });
      setUser({ ...user, ...data.buyItemStore });
    });
  };
  const handleBuyDice = (itemKey) => {
    if (loading) {
      return;
    }
    buyItemStore({
      variables: {
        itemKey,
        type: STORE_ITEM_TYPE.DICE,
      },
    }).then(({ data }) => {
      track("item_purchased", { item_key: itemKey, item_type: STORE_ITEM_TYPE.DICE });
      setUser({ ...user, ...data.buyItemStore });
    });
  };

  setPageTitle(t("t:players", "__players"));
  if (loading) return <Loading />;
  return (
    <Wrapper>
      <h1>{t("t:Shop", "__Shop")}</h1>
      <br />
      {(error || errorBuy) && <QueryError error={error || errorBuy} />}

      <StoreBadges
        tooth={user ? user.tooth : 0}
        onBuy={handleBuy}
        loading={loadingBuy}
        purchases={data?.me?.purchases || []}
      />
      <br />
      <StoreDice
        tooth={user ? user.tooth : 0}
        onBuy={handleBuyDice}
        loading={loadingBuy}
        purchases={data?.me?.purchases || []}
      />
      <br />
      <StoreAvatars
        tooth={user ? user.tooth : 0}
        onBuy={handleBuyAvatar}
        onBuySeasonAvatar={handleBuySeasonAvatar}
        loading={loadingBuy}
        purchases={data?.me?.purchases || []}
      />
    </Wrapper>
  );
});

const StoreShow = memo(() => {
  const { user } = useContext(RootContext);

  return <StoreShowWithUser user={user} />;
});

export default StoreShow;
